import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import BasicTable from "../../components/basicTable/BasicTable";

export default function ContactDetails(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Typography variant="h1" sx={{fontSize:`${fontSize+0.5}rem`, margin:"5px 0"}}>Contact Details</Typography>
            <hr/>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                 <div style={{fontSize:`${fontSize+0.1}rem`}}>
                 Meghalaya Society for Social Audit and Transparency (MSSAT)
                 </div>
                 <br/>
                 <div style={{display:"flex", justifyContent:"center", width:"100%"}}>

                    <BasicTable heading={heading} data={data1}/> {/* First Table */}
                 </div>
            </Box>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                 <div style={{fontSize:`${fontSize+0.1}rem`}}>
                 District Programme Coordinator (MGNREGA)
                 </div>
                 <br/>
                 <div style={{display:"flex", justifyContent:"center", width:"100%"}}>

                    <BasicTable heading={heading} data={data2}/> {/* Second Table */}
                 </div>
            </Box>
        </Box>
    )
}
const heading=[
    {
        data:"Sl. No.",
        width:"10%"
    },
    {
        data:"Name",
        width:"30%"
    },
    {
        data:"Designation",
        width:"20%"
    },
    {
        data:"Email Adress",
        width:"20%"
    },
    {
        data:"Phone No.",
        width:"20%"
    }
]

const data1=[
    ["1","Shri. Jonathan Pyngrope","Director","dir.mssat@gmail.com","--"],
    ["2","Smt. A. Myrthong","Joint Director"," mssatmeghalaya@gmail.com","9615927024"],
    ["3","Smt. D. Nongrum","Social Audit Expert","birzee.dipy@gmail.com","9863316246"],
    ["4","Shri J. D. Shira","Program Manager Administration","jsjdshira@gmail.com","8416071316"],
    ["5","Shri. Russel Markus K Shallam","Junior Consultant","russelmssat@gmail.com","8413010219"],
    ["6","Gracefullness Rymmai","Junior Consultant","grace.mssat@gmail.com","9774881817"],
    ["7","Malvern Lyngskor","Junior Consultant","mallyngskor@gmail.com","8131859514"],
    ["8","Joshua Marbaniang","Junior Consultant","joshuamssat@gmail.com","8012465702"],
    ["9","Shri. Stefan Wann","Junior Consultant","stefanmssat@gmail.com","7005544780"],
    ["10","Smt. Ivy Ch. Marak","Junior Consultant","ivymssat@gmail.com","9774481942"],
    ["11","Shri. Pynshaitborlang Lyngdoh Nongrang","Accountant Cum Office Assistant","pynshaitbor66d@gmail.com","8794748799"],
    ["12","Smt. Adelyne Khongwir","Program Manager-Human Resource","hrmssat@gmail.com","9856822516"],
    ["13","Smt Acenta C. Khasain","Program Manager Accounts & Audit","aamssat@gmail.com","9366015680"],
    ["14","Shri. Reebok Nathanial Diengdoh","Program Manager - Web, IT & DA.","mssatnathan08@gmail.com","7005811782"],
    ["15","Shri. Pynshailang Dann","Multi Tasking  Staff cum Driver","-","-"],
    ["16","Shri. Lurshai Syiemlieh","Multi Tasking  Staff","-","-"],
]
const data2=[
    ["1","District Programme Coordinator","East Khasi Hills","ekhmgnrega@gmail.com","0364 - 2224666"],
    ["2","District Programme Coordinator","West Khasi Hills","drda-wkh-meg@nic.in","03654 - 280221"],
    ["3","District Programme Coordinator","South West Khasi Hills","drda-swkh-meg@gov.in","-"],
    ["4","District Programme Coordinator","West Jaintia Hills","drdajowai@yahoo.in","03652 - 220859"],
    ["5","District Programme Coordinator","East Jaintia Hills","drdakhliehriat@gmail.com","03655-230713"],
    ["6","District Programme Coordinator","Ri Bhoi","drda-rb-meg@nic.in","03638 - 232571 "],
    ["7","District Programme Coordinator","West Garo Hills","drdawghtura@gmail.com","03651-224094"],
    ["8","District Programme Coordinator","East Garo Hills","eghnrega@gmail.com","03658 - 220320"],
    ["9","District Programme Coordinator","South West Garo Hills","drda.swgh.ampati@gmail.com","03651 - 221365"],
    ["10","District Programme Coordinator","South Garo Hills","drdabaghmara@gmail.com","03639 – 222281"],
    ["11","District Programme Coordinator","North Garo Hills","pddrdaresu@gmail.com","-"]
]

